import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import connect from 'app/libs/connect';
import S from 'app/features/landing/heroBlock/components/HeroBlock.styled';
import Perks from 'app/features/landing/heroBlock/components/Perks';
import Heading from 'app/components/layout/Heading.styled';
import {
  titleKey,
  imageUrl,
  imageUrl2X,
  isPerksVisible,
  titleColor,
} from 'app/features/landing/heroBlock/selectors';
import { isMultiTier } from 'app/features/products/selectors';
import HeroBlockProductCta from 'app/features/landing/heroBlock/components/HeroBlockProductCta';
import HeroBlockViewPlansCta from 'app/features/landing/heroBlock/components/HeroBlockViewPlansCta';

const UI = ({
  titleKey,
  titleColor,
  imageUrl,
  imageUrl2X,
  isPerksVisible,
  isMultiTier,
}) => (
  <S.HeroBlock data-t="hero-block-section">
    <S.HeroBlock.ImageWrapper>
      <S.HeroBlock.Image
        src={imageUrl}
        srcSet={`${imageUrl2X} 2x`}
        alt="background"
      />
    </S.HeroBlock.ImageWrapper>
    <S.HeroBlock.TitleWrapper>
      <Heading
        size="xl"
        type="heavy"
        as={S.HeroBlock.Title}
        titleColor={titleColor}
      >
        <FormattedMessage id={titleKey} />
      </Heading>
      {isMultiTier ? <HeroBlockViewPlansCta /> : <HeroBlockProductCta />}
    </S.HeroBlock.TitleWrapper>
    {isPerksVisible && <Perks />}
  </S.HeroBlock>
);

UI.propTypes = {
  titleKey: PropTypes.string.isRequired,
  titleColor: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageUrl2X: PropTypes.string.isRequired,
  isPerksVisible: PropTypes.bool.isRequired,
  isMultiTier: PropTypes.bool.isRequired,
};

UI.displayName = 'HeroBlock';

const state = {
  titleKey,
  imageUrl,
  imageUrl2X,
  isPerksVisible,
  titleColor,
  isMultiTier,
};

const HeroBlock = connect(state)(UI);

export { UI };

export default HeroBlock;
